// extracted by mini-css-extract-plugin
module.exports = {"centered-column-layout":"centered-column-layout__m6fq0"};